import Login from './views/Login.vue'
import ApplyOn from './views/ApplyOn.vue'
import Forget from './views/Forget.vue'
import Register from './views/Register.vue'
import ResetPassword from './views/ResetPassword.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import Main from './views/Main.vue'
import ProductList from './views/individual/product/ProductList'
import TrialList from './views/individual/trial/TrialList'
import AccountList from './views/individual/account/AccountList'

import Management from './views/individual/Management'
import Device from './views/individual/companys/Device'
import Company from './views/individual/companys/Company'
import WeProduct from './views/individual/companys/WeProduct'
import Statistics from './views/individual/companys/Statistics'
import CompanyAll from './views/individual/companys/CompanyAll'

import integral from './views/integral/index'
import IframePage from './views/IframePage.vue'


import store from './vuex/store';

let routes = [
    // {
    //     path: '/loginAdmin',
    //     component: LoginAdmin,
    //     name: '',
    //     hidden: true
    // },
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/applyOn',
        component: ApplyOn,
        name: '',
        hidden: true
    },
    
    {
        path: '/forget',
        component: Forget,
        name: '',
        hidden: true
    },
    {
        path: '/register',
        component: Register,
        name: '',
        hidden: true
    },
    {
        path: '/reset',
        component: ResetPassword,
        name: '',
        hidden: true
    },
    
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    // { path: '/main', component: Main,name:'控制台' },
    { 
        path: '/aiLab', 
        component: IframePage, 
        name: 'AI实验室',
        hidden: true
    },
    
    {
        path: '/',
        component: Home,
        name: '我的产品',
        meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
        children: [
            { 
                path: 'management', 
                component: Management, 
                name: '控制台' ,
                meta: {
                    requireAuth: true,
                },
            },
            { 
                path: 'productList', 
                component: ProductList, 
                name: '我的产品'  ,
                meta: {
                    requireAuth: true,
                },
            },
            //  { path: 'trialList', component: TrialList, name: '申请试用' },
            { 
                path: 'accountList', 
                component: AccountList, 
                name: '我的账户'  ,
                meta: {
                    requireAuth: true,
                },
            },
            { 
                path: 'companyAll', 
                component: CompanyAll, 
                name: '企业管理'  ,
                meta: {
                    requireAuth: true,
                },
            },
            { 
                path: 'integral', 
                component: integral, 
                name: '积分商城'  ,
                meta: {
                    requireAuth: true,
                },
            },
            // { 
            //     path: 'company', 
            //     component: Company, 
            //     name: '企业用户'  ,
            //     meta: {
            //         requireAuth: true,
            //     },
            // },
            // { 
            //     path: 'weProduct', 
            //     component: WeProduct, 
            //     name: '产品管理'  ,
            //     meta: {
            //         requireAuth: true,
            //     },
            // },
            // { 
            //     path: 'device', 
            //     component: Device, 
            //     name: '设备管理'  ,
            //     meta: {
            //         requireAuth: true,
            //     },
            // },
            // { 
            //     path: 'statistics', 
            //     component: Statistics, 
            //     name: '分析统计'  ,
            //     meta: {
            //         requireAuth: true,
            //     },
            // },

            
            
            // { path: 'module', component: Module, name: '模块管理' },
            // { path: 'admin', component: Admin, name: '管理员管理' },
            // { path: 'account', component: Account, name: '用户管理' },
        ],
    },
    {path:'*',redirect:'/'},


];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js